import * as Sentry from "@sentry/browser";

export const refactorErrorMessage = (error) => {
    if (!error) return {message: ''};

    const errorLower = String(error.message).toLowerCase();

    const isUserNameError = errorLower.includes('username');
    const isPasswordError = errorLower.includes('password');

    if (isUserNameError && !isPasswordError) {
        return {username: error.message};
    }
    if (!isUserNameError && isPasswordError) {
        return {password: error.message};
    }

    return {message: error.message};
};

export const setSentryUser = (action) => {
    try {
        Sentry.setUser({
            id: action?.payload?.user?.attributes?.sub,
        });
    } catch (e) {
        console.error({sentryErrorSetUser: e});
    }
}
